import { Link } from "react-router-dom";
import recentPost1 from "../../assets/images/all-img/blog/recent-post1.png";
import recentPost2 from "../../assets/images/all-img/blog/recent-post2.png";
import recentPost3 from "../../assets/images/all-img/blog/recent-post3.png";
import search from "../../assets/images/svg/search.svg";

export default function SingleBlogSidebarSection() {
	return (
		<div className="fugu-blog-sidebar">
			<div className="fugu-sidebar-item">
				<form action="#">
					<div className="fugu-product-search">
						<input type="search" placeholder="Type to search..." />
						<button id="fugu-search-btn">
							<img src={search} alt="" />
						</button>
					</div>
				</form>
			</div>
			<div className="fugu-sidebar-item">
				<div className="fugu-sidebar-item-title">
					<h5>Blog Categories</h5>
				</div>
				<div className="fugu-categories">
					<ul>
						<li>
							<Link to={"#"}> Cryptocurrency (05) </Link>
						</li>
						<li>
							<Link to={"#"}> Web Development (18) </Link>
						</li>
						<li>
							<Link to={"#"}> Marketing (59) </Link>
						</li>
						<li>
							<Link to={"#"}> Data Analysis (03) </Link>
						</li>
					</ul>
				</div>
			</div>
			<div className="fugu-sidebar-item">
				<div className="fugu-sidebar-item-title">
					<h5>Recent Posts</h5>
				</div>
				<div className="fugu-recent-post-item">
					<Link to={"#"}>
						<img src={recentPost1} alt="" />
					</Link>
					<div className="fugu-blog-meta">
						<ul>
							<li>
								<Link to={"#"}> Article </Link>
							</li>
							<li>
								<Link to={"#"}> August 26, 2022 </Link>
							</li>
						</ul>
					</div>
					<h6>
						<Link to={"#"}>
							Blockchain and government will they have live happily ever after trade crypto world?
						</Link>
					</h6>
				</div>
				<div className="fugu-recent-post-item">
					<Link to={"#"}>
						<img src={recentPost2} alt="" />
					</Link>
					<div className="fugu-blog-meta">
						<ul>
							<li>
								<Link to={"#"}> Article </Link>
							</li>
							<li>
								<Link to={"#"}> August 26, 2022 </Link>
							</li>
						</ul>
					</div>
					<h6>
						<Link to={"#"}>
							Blockchain receives the exclusive have quin hyperledger service provider certification
						</Link>
					</h6>
				</div>
				<div className="fugu-recent-post-item">
					<Link to={"#"}>
						<img src={recentPost3} alt="" />
					</Link>
					<div className="fugu-blog-meta">
						<ul>
							<li>
								<Link to={"#"}> Article </Link>
							</li>
							<li>
								<Link to={"#"}> August 26, 2022 </Link>
							</li>
						</ul>
					</div>
					<h6>
						<Link to={"#"}>
							Espeo is recognized by techreviewer as a top blockchain development company in 2021
						</Link>
					</h6>
				</div>
			</div>
			<div className="fugu-sidebar-item">
				<div className="fugu-sidebar-item-title">
					<h5>Tags</h5>
				</div>
				<div className="fugu-tags">
					<ul>
						<li>
							<Link to={"#"}> #Sponsored </Link>
						</li>
						<li>
							<Link to={"#"}> #Business </Link>
						</li>
						<li>
							<Link to={"#"}> #UI / UX Design </Link>
						</li>
						<li>
							<Link to={"#"}> #Marketing </Link>
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
}
